<template>
  <div>
      <div class="topo ui-container">
        <div class="container">
          <ul class="row align-items-center justify-content-center">
            <li v-if="actualEmpreendimento.start_date">
              <div class="topo__titulo">
                Data de início
              </div>
              <div class="topo__data">
                {{actualEmpreendimento.start_date}}
              </div>
            </li>
            <li v-if="actualEmpreendimento.end_date">
              <div class="topo__titulo">
                Data de término
              </div>
              <div class="topo__data">
                {{actualEmpreendimento.end_date}}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="estagio ui-container" v-if="empreendimentoEstagios.length > 1">
        <div class="container">
          <ul class="row justify-content-center">
            <li class="col-xl-2 col-md-3 col-12 text-center" v-for="(stage,index) in empreendimentoEstagios"
              :key="index">
              <div class="hover-text">
                <p>
                  {{stage.lead}}
                </p>
              </div>
              <!-- printar o valor dentro de data-percentage, somente números inteiros -->
              <div class="progress" :data-percentage="stage.value">
                <span class="progress-left">
                  <span class="progress-bar"></span>
                </span>
                <span class="progress-right">
                  <span class="progress-bar"></span>
                </span>
                <div class="progress-value">
                  <div v-if="stage.image != ''" class="progress-image ui-image--contain" :style="'background-image: url('+stage.image+');'"></div>
                  <div class="progress-value-number" :class="!stage.image ? 'progress-no-image':''">
                    {{stage.value}}%
                  </div>
                </div>
              </div>
              <div class="title-progress">
                {{stage.title}}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="andamento ui-container" v-if="empreendimentoDates.months">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="ui-subtitle--interna">
                <h2>
                  Confira o andamento da obra
                </h2>
              </div>
            </div>
            <div class="col-md-2 col-12">
              <div class="andamento__ano">
                <select v-model="selectedYear" @change="changeYear(selectedYear)">
                  <option v-for="(year,index) in empreendimentoDates.years" @value="year.year" :key="index">{{year.year}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-10 col-12" v-if="empreendimentoDates.months.length > 0">
              <carousel class="carousel"
              v-if="empreendimentoDates.months.length > 0"
              :per-page="1"
              :paginationPadding="5"
              :paginationSize="15"
              :paginationActiveColor="'#13182c'"
              :perPageCustom="[[300, 2], [768, 3], [1024, 3], [1200, 4]]"
              :loop="false"
              :autoplay="false"
              :paginationEnabled="false"
              :navigationEnabled="true"
              navigationNextLabel='<i class="fa fa-chevron-right data_right"></i>'
              navigationPrevLabel='<i class="fa fa-chevron-left data_left" aria-hidden="true"></i>'
              >
                <slide v-for="(month,index) in empreendimentoDates.months" :key="index" v-if="selectedYear == month.year">
                  <div class="andamento__mes" @click="mostraGaleria(month.month)" :class="{'active' : month.month == tab}">
                    <div class="box">
                      {{month.monthName}}
                    </div>
                  </div>
                </slide>
              </carousel>
            </div>
            <div class="col-12">
              <div
              v-if="empreendimentoDates.months && empreendimentoDates.months.length >= 1"
              class="andamento__galeria"
              v-for="(item,index) in empreendimentoDates.months"
              :key="index"
              v-show="tab == item.month && selectedYear == item.year"
              >
                <ul class="row align-items-center">
                  <li class="col-md-4 col-lg-3 col-sm-6 col-12" v-for="(item,indexInterno) in monthImages" :key="indexInterno" v-if="tab == item.month && item.year == selectedYear">
                    <div class="andamento__imagens w-100 text-center">
                      <div class="row align-items-center h-100">
                        <div @click="galery(indexInterno)" :style="`background-image: url(${item.image}); background-position: center; background-size: cover; background-repeat: no-repeat; width: 100%; height: 100%;`"></div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div
                class="images"
                v-viewer="{movable: false, title: false, scalable: false}"
                style="display: none;"
              >
                <img
                  v-for="(item,index2) in monthImages"
                  :key="index2"
                  :src="item.image"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Vue from 'vue'
import { mapGetters } from 'vuex'
Vue.use(Viewer)
export default {
  data () {
    return {
      tab: 0,
      selectedYear: '',
      arrayMes: [
        {
          'id': 1,
          'mes': 'Janeiro'
        },
        {
          'id': 2,
          'mes': 'Fevereiro'
        },
        {
          'id': 3,
          'mes': 'Março'
        },
        {
          'id': 4,
          'mes': 'Abril'
        },
        {
          'id': 5,
          'mes': 'Maio'
        },
        {
          'id': 6,
          'mes': 'Junho'
        },
        {
          'id': 7,
          'mes': 'Julho'
        },
        {
          'id': 8,
          'mes': 'Agosto'
        },
        {
          'id': 9,
          'mes': 'Setembro'
        },
        {
          'id': 10,
          'mes': 'Outubro'
        },
        {
          'id': 11,
          'mes': 'Novembro'
        },
        {
          'id': 12,
          'mes': 'Dezembro'
        }
      ],
      monthImages: [],
      options: {
        title: false,
        scalable: false
      }
    }
  },
  components: {
    Carousel,
    Slide
  },
  methods: {
    mostraGaleria (item) {
      this.tab = item
      this.monthImages = []
      this.empreendimentoEstagioGaleria.forEach(image => {
        if (image.month === item) {
          this.monthImages.push(image)
        }
      })
    },
    changeYear (year) {
      for (let x = 0; x < this.empreendimentoDates.months.length; x++) {
        year = Number(year)
        if (this.empreendimentoDates.months[x].year === year) {
          this.tab = this.empreendimentoDates.months[x].month
          return true
        }
      }
    },
    galery (id) {
      const viewer = this.$el.querySelector('.images').$viewer
      viewer.view(id)
      viewer.show()
    }
  },
  computed: {
    ...mapGetters([
      'actualEmpreendimento',
      'empreendimentoEstagios',
      'empreendimentoDates',
      'empreendimentoEstagioGaleria'
    ])
  },
  created () {
    this.$store.dispatch('showEmpreendimento', this.$route.params.slug)
    this.$store.dispatch('showEmpreendimentoEstagios', this.$route.params.slug)
    this.$store.dispatch('showEmpreendimentoEstagiosDates', this.$route.params.slug)
      .then(() => {
        if (this.empreendimentoDates.years[0]) {
          this.selectedYear = this.empreendimentoDates.years[0].year
          for (let x = 0; x < this.empreendimentoDates.months.length; x++) {
            if (this.empreendimentoDates.months[x].year === this.selectedYear) {
              if (this.tab === 0) {
                this.tab = this.empreendimentoDates.months[x].month
              }
            }

            for (let i = 0; i < this.arrayMes.length; i++) {
              if (this.empreendimentoDates.months[x].month === this.arrayMes[i].id) {
                this.empreendimentoDates.months[x].monthName = this.arrayMes[i].mes
              }
            }
          }
        }
      })
    this.$store.dispatch('showEmpreendimentoEstagiosGaleria', this.$route.params.slug).then(() => {
      this.empreendimentoEstagioGaleria.forEach(image => {
        if (image.month === this.tab) {
          this.monthImages.push(image)
        }
      })
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.topo {
  background: $primary;
  li {
    margin: 0 40px;
    padding-left: 50px;
    position: relative;
    &:before {
      background: url(../../assets/img/icon-calendar.png);
      content: '';
      height: 32px;
      left: 0;
      position: absolute;
      top: 5px;
      width: 30px;
    }
    @media (max-width: 767px) {
      margin: 20px 0;
      padding-left: 80px;
      &:before {
        left: 40px;
      }
      width: 100%;
    }
  }
  &__titulo {
    color: white;
    font-size: 16px;
    font-weight: 900;
    margin-bottom: 0px;
    text-transform: uppercase
  }
  &__data {
    color: white;
    font-size: 16px;
    font-style: italic;
    font-weight: 300;
  }
}

.carousel{
  display: inline-flex;
}

.andamento {
  background: $bgIntern;
  overflow: hidden;
  &__ano {
    position: relative;
    select {
      background: none;
      border: 1px $effect solid;
      border-left: none;
      border-right: none;
      border-top: none;
      color: $lead;
      cursor: pointer;
      font-style: italic;
      font-weight: 300;
      outline: none;
      padding: 5px 5px 6px 40px;
      width: 100%;
      &:focus {
        color: $primary;
        border-color: $primary;
        font-weight: 600;
        outline: none;
      }
      @media (max-width: 991px) {
        padding-left: 5px;
      }
      @media (max-width: 767px) {
        margin-bottom: 20px;
      }
    }
    &:before {
      background: url(../../assets/img/icon-calendar-silver.png);
      content: '';
      height: 22px;
      left: 10px;
      position: absolute;
      top: 3px;
      width: 21px;
      @media (max-width: 991px) {
        display: none;
      }
    }
  }
  &__mes {
    margin: 0 10px;
    .box {
      background: white;
      border-radius: 5px;
      border: 1px $effect solid;
      color: $effect;
      cursor: pointer;
      font-size: 16px;
      margin: 0 10px;
      overflow: hidden;
      padding: 13px 40px;
      position: relative;
      text-align: center;
      width: 100%;
      @media (max-width: 991px) {
        padding: 13px 20px;
      }
      @media (max-width: 767px) {
        margin: 0px;
      }
    }
  }
  .active {
    .box {
      background: $primary;
      border: none;
      color: white;
      &:before {
        background: $green;
        bottom: 0;
        content: '';
        height: 5px;
        left: 0;
        position: absolute;
        width: 100%;
      }
    }
  }
  &__galeria {
    margin-top: 50px;
    @media (max-width: 991px) {
      margin-top: 30px;
    }
  }
  li {
    margin-bottom: 30px;
  }
  &__imagens {
    border-radius: 10px;
    box-shadow: 0px 7px 30px 10px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    height: 230px;
    overflow: hidden;
    position: relative;
    transition: all 0.3s;
    img {
      transform: scale(1.2);
    }
    // &:before {
    //   background: url(../../assets/img/bg_galeria_interna.png);
    //   background-position: center;
    //   background-size: cover;
    //   background-repeat: no-repeat;
    //   display: none;
    //   content: '';
    //   height: 100%;
    //   left: 0;
    //   position: absolute;
    //   top: 0;
    //   transition: all 0.3s;
    //   width: 100%;
    // }
    &:hover {
      transition: all 0.3s;
      opacity: 0.8;
      // &:before {
      // }
    }
  }
}
.estagio {
  li {
    margin-bottom: 30px;
    position: relative;
    .hover-text {
      background: white;
      border-radius: 10px;
      box-shadow: 20px 20px 35px 0px rgba(0, 26, 66, 0.2);
      display: none;
      min-height: 200px;
      left: -45px;
      position: absolute;
      bottom: 100%;
      padding: 20px;
      width: 290px;
      z-index: 50;
      p {
        color: $silver;
        font-size: 16px;
        font-style: talic;
        font-weight: 300;
        line-height: 26px;
      }
      &:after {
        background: url(../../assets/img/poligono.png);
        bottom: -20px;
        content: '';
        left: calc(50% - 16px);
        height: 27px;
        position: absolute;
        width: 33px;
        z-index: 50;
      }
    }
    &:hover {
      .hover-text{
        display: block;
      }
    }
    @media (max-width: 767px) {
      .hover-text {
        width: 100%;
        max-width: 300px;
        left: calc(50% - 150px);
      }
    }
  }
}

$borderWidth: 9px;
$animationTime: 2.3s;
$border-color-default: #f2f2f2;
$border-color-fill: #009337;
$size: 150px;
$howManySteps: 100;

.progress-no-image {
  padding-top: 35px;
}
.progress {
  width: $size;
  height: $size;
  background: none;
  box-shadow: none;
  margin: 0 auto;
  position: relative;
  &:after {
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: $borderWidth solid $border-color-default;
    position: absolute;
    top: 0;
    left: 0;
  }
  > span {
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1;
  }
  .progress-left {
    left: 0;
  }
  .progress-bar {
    width: 100%;
    height: 100%;
    background: none;
    border-width: $borderWidth;
    border-style: solid;
    position: absolute;
    top: 0;
    border-color: $border-color-fill;
  }
  .progress-left .progress-bar {
    left: 100%;
    border-top-right-radius: ($size/2);;
    border-bottom-right-radius: ($size/2);;
    border-left: 0;
    -webkit-transform-origin: center left;
    transform-origin: center left;
  }
  .progress-right {
    right: 0;
    .progress-bar {
      left: -100%;
      border-top-left-radius: ($size/2);;
      border-bottom-left-radius: ($size/2);;
      border-right: 0;
      -webkit-transform-origin: center right;
      transform-origin: center right;
    }
  }
  .progress-value {
    align-items: center;
    //display: flex;
    padding-top: 35px;
    text-align: center;
    width: 150px;
  }
}
.title-progress {
  color: $silver;
  font-size: 20px;
  font-style: italic;
  font-weight: 600;
  margin-top: 20px;
  @media (max-width: 767px) {
    font-size: 18px;
  }
}
.progress-value-number {
  color: $silver;
  font-size: 32px!important;
  font-weight: 900;
  line-height: 20px;
  text-align: center;
  width: 100%;
}
.progress-image {
  margin: 0 auto;
  height: 47px;
  margin-bottom: 10px;
  width: 47px;
}
@for $i from 1 through $howManySteps {
$stepName: ($i*(100 / $howManySteps));
@if $i <= ($howManySteps/2) {
  .progress[data-percentage="#{$stepName}"] {
    .progress-right .progress-bar {
      animation: loading-#{$i} $animationTime linear forwards;
    }
    .progress-left .progress-bar {
      animation: 0;
    }
  }
}
@if $i > ($howManySteps/2) {
  .progress[data-percentage="#{$stepName}"] {
    .progress-right .progress-bar {
      animation: loading-#{($howManySteps/2)} $animationTime linear forwards;
    }
    .progress-left .progress-bar {
      animation: loading-#{$i - ($howManySteps/2)} $animationTime linear forwards $animationTime;
    }
  }
}
}
@for $i from 1 through ($howManySteps/2) {
  $degrees: (180/($howManySteps/2));
  $degrees: ($degrees*$i);
  @keyframes loading-#{$i}{
    0%{
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100%{
      -webkit-transform: rotate($degrees);
      transform: rotate(#{$degrees}deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/InternaEstagio.vue